import { TenantSlug } from "../../sharedConfig.mjs";
import { CredentialVendor } from "../../credentialVendor.mjs";
import { demoClinicConfig } from "./clinic.mjs";
import { demoProviderRouting } from "./routing.mjs";

//#region src/tenants/demo/index.ts
const demo = {
	slug: TenantSlug.Demo,
	displayName: "Demo",
	vendors: [CredentialVendor.Spruce],
	libretto: { workflows: {
		pullReferrals: {},
		sendReferral: {},
		checkEligibility: {},
		submitPriorAuth: {},
		recordPatientConsent: {}
	} },
	clinic: demoClinicConfig,
	routing: demoProviderRouting,
	autoAssignReferralsToAgent: false,
	residentialProxy: {
		country: "US",
		state: "TX",
		city: "austin"
	},
	auth: {
		sso: [],
		password: true
	},
	spruce: {
		orgId: "entity_2PLJA21BKQG00",
		departmentEndpoints: { "Demo Department": "ZW50aXR5XzJQTEpBMjFCS1FHMDA6KzE2MDI1ODQwMTQyOnBob25l" }
	},
	demoFeatures: {
		sendRealTexts: true,
		sendRealCalls: true,
		sendRealEligibilityCheck: false,
		sendRealPriorAuth: false,
		pullRealReferrals: false,
		sendRealFax: false
	}
};

//#endregion
export { demo };